import {
  UilClipboardAlt,
  UilWebGrid,
  UilUtensils,
  UilListUl,
  UilPen,
  UilHistory,
  UilShoppingCart,
  UilChart,
  UilComment,
  UilShoppingBag,
  UilUsersAlt,
  UilBox,
  UilSignOutAlt,
} from "@iconscout/react-unicons";

export const SIDEBAR_CONFIG = [
  {
    id: "dashboard",
    icon: () => <span className="text-lg">📊</span>, // Dashboard chart emoji
    heading: "Dashboard",
    link: "/dashboard",
    roles: ["admin", "superAdmin"],
  },
  {
    id: "product-management",
    icon: UilBox, // Better box icon for products
    heading: "Product Management",
    roles: ["admin", "superAdmin"],
    submenu: [
      { heading: "Products", link: "/product" },
      { heading: "Category", link: "/categories" },
      { heading: "Subcategory", link: "/subcategories" },
      { heading: "Update", link: "/price-update" },
      { heading: "Report", link: "/reports", roles: ["superAdmin"] },
    ],
  },
  {
    id: "banner",
    icon: UilWebGrid,
    heading: "Banner",
    link: "/banner",
    roles: ["admin", "superAdmin"],
  },
  {
    id: "table-bookings",
    icon: UilUtensils,
    heading: "Table Bookings",
    link: "/table-booking",
    roles: ["waiter", "admin", "superAdmin"],
  },
  // {
  //     id: "qr-bookings",
  //     icon: UilPen,
  //     heading: 'Qr Booking',
  //     link: "/qrordering",
  //     roles: ["admin", "superAdmin"],
  // },
  {
    id: "online-orders",
    icon: UilShoppingCart, // Better shopping cart icon for orders
    heading: "Online Orders",
    link: "/orderdetails",
    roles: ["admin", "superAdmin"],
  },
  {
    id: "orders-report",
    icon: UilChart,
    heading: "Report",
    link: "/orders-history",
    roles: ["admin", "superAdmin"],
  },

  {
    id: "user-feedback",
    icon: UilComment, // Better comment icon for feedback
    heading: "User Feedback",
    link: "/feedback",
    roles: ["admin", "superAdmin"],
  },

  {
    id: "takeaway",
    icon: UilShoppingBag, // Better shopping bag icon for takeaway
    heading: "Takeaway",
    link: "/takeaway",
    roles: ["admin", "superAdmin"],
  },
  {
    id: "user-management",
    icon: UilUsersAlt, // Better users icon for user management
    heading: "User Management",
    roles: ["admin", "superAdmin"],
    submenu: [
      {
        heading: "Add User",
        link: "/addusers",
        roles: ["superAdmin", "admin"],
      },
    ],
  },
];
